import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/California.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Mobile App Development in California?
            </h2>
            <p>
              TekRevol offers the best mobile app development in California,
              backed with cutting edge technologies, and frameworks. Our team
              excels in crafting custom mobile apps that precisely align with
              your specific business needs and objectives, ensuring a perfect
              fit.
            </p>
            <p>
              We consistently lead the way in mobile technology trends,
              utilizing the latest tools and frameworks to create innovative and
              future-proof apps. Our agile development approach ensures rapid
              iterations, swift outcomes, and adaptability to evolving
              requirements. As a result, we provide cost-effective solutions
              without compromising quality, making mobile app development
              accessible to businesses of all sizes.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
